import actions from "./actions";

export default {
  namespaced: true,
  state: {
    liveCategories: [],
    live: {}
  },
  mutations: {
    setLiveCategories(state, liveCategories) {
      state.liveCategories = liveCategories;
    },
    setLives(state, { id, lives }) {
      const data = { ...state.liveCategories };
      for (let i in data) {
        if (data[i].id == id) {
          data[i].lives = lives;
          break;
        }
      }
      state.liveCategories = data;
    },
    setLive(state, live) {
      state.live = live;
    }
  },
  actions
};
